import { portalGradeLabel } from './portalGradeLabel'
import { displayDate } from '@/lib/dates'
import { Badge } from '@/components/ui/badge'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  SortableTableHead,
} from '@/components/ui/table'
import type {
  PortalActivityListData,
  PortalActivityListKind,
  PortalCourseRow,
} from './portalActivityLists.types'

export function PortalActivityTable({
  rows,
  kind,
  sort,
  onSort,
}: {
  rows: PortalActivityListData['rows']
  kind: PortalActivityListKind
  sort: string
  onSort: (sort: string) => void
}) {
  const head = (key: string, label: string) => {
    const [selected, direction] = sort.split(':')
    const next = selected === key && direction === 'asc' ? 'desc' : 'asc'
    return (
      <SortableTableHead
        active={selected === key}
        direction={direction === 'desc' ? 'descending' : 'ascending'}
        initialDirection={key === 'completed' ? 'descending' : 'ascending'}
        onToggle={() => onSort(`${key}:${selected !== key && key === 'completed' ? 'desc' : next}`)}
      >
        {label}
      </SortableTableHead>
    )
  }
  return (
    <Table className="min-w-max [&_th]:whitespace-nowrap">
      <TableHeader>
        <TableRow>
          {head('person', 'Person')}
          {kind === 'courses' ? (
            <>
              <TableHead>Course</TableHead>
              <TableHead>Status</TableHead>
              {head('completed', 'Completed')}
              <TableHead>Grade</TableHead>
              <TableHead className="text-right">Credits</TableHead>
            </>
          ) : (
            <TableHead>Level</TableHead>
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={index}>
            {'course' in row ? (
              <CourseCells row={row} />
            ) : (
              <>
                <TableCell>{row.person}</TableCell>
                <TableCell>{row.level}</TableCell>
              </>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
function CourseCells({ row }: { row: PortalCourseRow }) {
  return (
    <>
      <TableCell>
        <span className="inline-flex items-center gap-1.5">
          <span className={row.person_status === 'erased' ? 'text-muted-foreground' : undefined}>
            {row.person_status === 'erased' ? 'Erased contact' : row.person}
          </span>
          {row.person_status === 'former' && <Badge variant="neutral">Former</Badge>}
        </span>
      </TableCell>
      <TableCell>{row.course}</TableCell>
      <TableCell>
        <Badge variant={row.status === 'completed' ? 'success' : 'info'}>
          {row.status === 'completed' ? 'Completed' : 'In progress'}
        </Badge>
      </TableCell>
      <TableCell>
        {row.status === 'completed' && row.completed_on ? displayDate(row.completed_on) : '—'}
      </TableCell>
      <TableCell>
        {row.status === 'completed' ? (portalGradeLabel(row.grade) ?? '—') : '—'}
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {row.status === 'completed' ? (row.credits ?? '—') : '—'}
      </TableCell>
    </>
  )
}
